var _defs, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliverTruckBulkCarrier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a403e7cc-bf97-4f7c-ab0e-b14d9432be68",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b4cee21c-1ac7-4db5-949f-207d2a9ce4a4,.ea787ea4-0686-4fb7-be2f-c7120d630236{fill:none;}.ea787ea4-0686-4fb7-be2f-c7120d630236{clip-rule:evenodd;}.afd9a31b-1f36-4d5b-9534-3c77484da589{clip-path:url(#af656ae1-5d4b-49a7-9346-5b1575ab15d9);}.ad3d2955-e224-42a8-8a2f-6cc49888eca5{fill:#d8d8d8;}.a2fa9ba2-21a3-4c1f-9521-2663f5a0a969{clip-path:url(#a126ba13-f868-48fc-8bb4-7f046c45d573);}.a2fc6b5a-de8e-475c-bbca-90356eb089d8{clip-path:url(#bbbcfe20-6caa-4984-8fa8-b997c7b5b000);}.e839d057-1cd7-400c-b918-9a8ef05af0eb{clip-path:url(#af7a2ea4-3047-4a44-93e2-37205a2f083f);}.a7236957-7905-41ae-8cf6-c5eb0ce39479{clip-path:url(#b92b699f-7f33-45f0-81d3-a9e0718c6d35);}.a346effb-fb38-4389-a3c3-477621c113f3{clip-path:url(#fa4fdbcc-556a-4053-a932-9aaa79664b57);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "af656ae1-5d4b-49a7-9346-5b1575ab15d9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ea787ea4-0686-4fb7-be2f-c7120d630236",
    d: "M7.71-14.86a1.09,1.09,0,0,0-1.09,1.1,1.09,1.09,0,0,0,1.09,1.09,1.09,1.09,0,0,0,1.1-1.09A1.1,1.1,0,0,0,7.71-14.86ZM12.49-18l9.1,3.62c.17.08.22.23.13.47l-3.16,8.3q-.89-1.38-4,.47c-3.12,1.85-2-2.27-5-.47q-3,1.8-4,0L2.28-14a.31.31,0,0,1,.18-.46q.33-.15,9-3.6v7.12c0,.22.1.33.31.33h.37c.21,0,.31-.11.31-.33Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a126ba13-f868-48fc-8bb4-7f046c45d573"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ea787ea4-0686-4fb7-be2f-c7120d630236",
    d: "M4.43,13.48h8.13c.51,0,2.19-3.41,2.19-4,0-1.9-.63-5-2.74-5s-3.93,0-7.46,0C.22,4.47-.5,13.49,4.43,13.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbbcfe20-6caa-4984-8fa8-b997c7b5b000"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4cee21c-1ac7-4db5-949f-207d2a9ce4a4",
    d: "M17.33,11.75a.28.28,0,0,0,.26.3h4.54a.28.28,0,0,0,.26-.29V11.5a.66.66,0,0,0-.05-.28L20.91,8.48a.62.62,0,0,0-.58-.39H17.81c-.41,0-.48,0-.48.5ZM2.11,15.34a1,1,0,0,1,1-.94h12.6a.59.59,0,0,0,.59-.6V7.32a.18.18,0,0,1,.18-.18h4.3a.94.94,0,0,1,.86.57l2.12,4v0a1,1,0,0,1,.08.38l-.05,7.55a1,1,0,0,1-.95.95h-.14a.18.18,0,0,1-.18-.18,3.18,3.18,0,1,0-6.35,0,.18.18,0,0,1-.18.18H15a.18.18,0,0,1-.18-.18,3.17,3.17,0,0,0-5.87-1.69.17.17,0,0,1-.3,0,3.17,3.17,0,0,0-5.84,1.74.22.22,0,0,0,0,.08,1,1,0,0,1-.71-1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af7a2ea4-3047-4a44-93e2-37205a2f083f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4cee21c-1ac7-4db5-949f-207d2a9ce4a4",
    d: "M19.31,21.34a.9.9,0,1,0-.89-.9A.89.89,0,0,0,19.31,21.34Zm0-3.44a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,19.31,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b92b699f-7f33-45f0-81d3-a9e0718c6d35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4cee21c-1ac7-4db5-949f-207d2a9ce4a4",
    d: "M11.63,21.34a.9.9,0,1,0-.89-.9A.89.89,0,0,0,11.63,21.34Zm0-3.44a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,11.63,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa4fdbcc-556a-4053-a932-9aaa79664b57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4cee21c-1ac7-4db5-949f-207d2a9ce4a4",
    d: "M6,21.35a.89.89,0,1,0-.89-.89A.88.88,0,0,0,6,21.35Zm0-3.43a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,6,17.92Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "afd9a31b-1f36-4d5b-9534-3c77484da589"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad3d2955-e224-42a8-8a2f-6cc49888eca5",
    x: -2.76,
    y: -23.04,
    width: 29.53,
    height: 23.35
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a2fa9ba2-21a3-4c1f-9521-2663f5a0a969"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad3d2955-e224-42a8-8a2f-6cc49888eca5",
    x: -3.99,
    y: -0.52,
    width: 23.73,
    height: 19
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a2fc6b5a-de8e-475c-bbca-90356eb089d8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad3d2955-e224-42a8-8a2f-6cc49888eca5",
    x: -2.92,
    y: 2.14,
    width: 31.72,
    height: 23.42
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "e839d057-1cd7-400c-b918-9a8ef05af0eb"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad3d2955-e224-42a8-8a2f-6cc49888eca5",
    x: 11.79,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "a7236957-7905-41ae-8cf6-c5eb0ce39479"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad3d2955-e224-42a8-8a2f-6cc49888eca5",
    x: 4.11,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "a346effb-fb38-4389-a3c3-477621c113f3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad3d2955-e224-42a8-8a2f-6cc49888eca5",
    x: -1.56,
    y: 12.92,
    width: 15.03,
    height: 15.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverTruckBulkCarrier);
export default __webpack_public_path__ + "static/media/deliver-truck-bulk-carrier.7ef34e805751bb4dca98e700b98e8b86.svg";
export { ForwardRef as ReactComponent };